/** Available balance report types */
export enum BalanceReportTypeEnum {
  /** Income statement */
  INCOME_STATEMENT = 'INCOME_STATEMENT',
  /** Cash flow */
  CASH_FLOW = 'CASH_FLOW',
}
